module.exports = __webpack_public_path__ + "img/price.425092ed.png";